export var DealerChannel;
(function (DealerChannel) {
    DealerChannel["LSP"] = "lsp";
    DealerChannel["MDU"] = "mdu";
    DealerChannel["D2D"] = "d2d";
    DealerChannel["EM"] = "em";
    DealerChannel["NR"] = "nr";
    DealerChannel["ISP"] = "isp";
})(DealerChannel || (DealerChannel = {}));
